import React from 'react'
import { RouteObject, Navigate } from 'react-router-dom'

import LoginPage from '@pages/core/auth/Login.page'
import AuthLoadingPage from '@pages/core/auth/AuthLoading.page'

// @PLOP-IMPORTS

/* eslint-disable */
const AuthRoute: RouteObject[] = [
	{ path: '/auth', element: <Navigate to="/auth/login" replace={true} /> },
	{ path: '/auth/login', element: <LoginPage /> },
	{ path: '/auth/loading', element: <AuthLoadingPage /> },

	// @PLOP-CODE
]
/* eslint-disable */

export default AuthRoute
